import './App.css';
import Scene from './scene';

function App() {
  return (
    <div className="App">
      <Scene/>
    </div>
  );
}

export default App;
